import React from 'react';

const ICON_PATHS = {
  gift: (
    <>
      <path d="M20 12v10H4V12" />
      <path d="M22 7H2v5h20V7z" />
      <path d="M12 22V7" />
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
    </>
  ),
  shield: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />,
  qr: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
    </>
  ),
  user: (
    <>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </>
  ),
  chevron: <polyline points="9 18 15 12 9 6" />,
  battery: (
    <>
      <rect x="2" y="7" width="16" height="10" rx="2" />
      <path d="M22 11v2" />
    </>
  ),
  wifi: (
    <>
      <path d="M5 12.55a11 11 0 0 1 14.08 0" />
      <path d="M1.42 9a16 16 0 0 1 21.16 0" />
      <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
      <line x1="12" y1="20" x2="12.01" y2="20" />
    </>
  ),
  signal: (
    <>
      <line x1="1" y1="20" x2="1" y2="14" />
      <line x1="6" y1="20" x2="6" y2="9" />
      <line x1="11" y1="20" x2="11" y2="4" />
      <line x1="16" y1="20" x2="16" y2="4" />
    </>
  ),
  dumbbell: (
    <>
      <path d="M6 5v14" />
      <path d="M18 5v14" />
      <path d="M2 9h4" />
      <path d="M20 9h2" />
      <path d="M2 15h4" />
      <path d="M20 15h2" />
      <path d="M6 9h12v6H6V9z" />
    </>
  ),
  coffee: (
    <>
      <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
      <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
      <line x1="6" y1="1" x2="6" y2="4" />
      <line x1="10" y1="1" x2="10" y2="4" />
      <line x1="14" y1="1" x2="14" y2="4" />
    </>
  ),
  shopping: (
    <>
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </>
  ),
  film: (
    <>
      <rect x="2" y="2" width="20" height="20" rx="2.18" />
      <line x1="7" y1="2" x2="7" y2="22" />
      <line x1="17" y1="2" x2="17" y2="22" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <line x1="2" y1="7" x2="7" y2="7" />
      <line x1="2" y1="17" x2="7" y2="17" />
      <line x1="17" y1="17" x2="22" y2="17" />
      <line x1="17" y1="7" x2="22" y2="7" />
    </>
  ),
  travel: (
    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21 4 19 2c-2-2-4-2-5.5-.5L10 5 1.8 6.2a1 1 0 0 0-.5 1.7l1.7 1.7L1.8 12a1 1 0 0 0 .3 1.3l1 .7 1.7 1.7.7 1c.3.5.9.7 1.3.3l2.4-1.2 1.7 1.7 1.7 1.7a1 1 0 0 0 1.7-.5L17.8 19.2z" />
  ),
  tag: (
    <>
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </>
  ),
  star: <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />,
  lock: (
    <>
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </>
  ),
  building: (
    <>
      <rect x="3" y="2" width="18" height="20" rx="1" />
      <path d="M9 22V12h6v10" />
      <line x1="3" y1="7" x2="21" y2="7" />
      <line x1="3" y1="12" x2="9" y2="12" />
      <line x1="15" y1="12" x2="21" y2="12" />
    </>
  ),
  check: <polyline points="20 6 9 17 4 12" />,
  menu: (
    <>
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </>
  ),
  x: (
    <>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </>
  ),
  store: (
    <>
      <path d="M2 3h20l-2 9H4L2 3z" />
      <circle cx="5" cy="19" r="2" />
      <circle cx="19" cy="19" r="2" />
      <line x1="4.27" y1="12" x2="19.73" y2="12" />
    </>
  ),
  'arrow-right': (
    <>
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </>
  ),
};

export const Icon = ({ name, size = 22, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {ICON_PATHS[name]}
  </svg>
);

export const AppleIcon = () => (
  <svg width="20" height="24" viewBox="0 0 20 24" fill="white">
    <path d="M16.7 12.8c0-2.8 2.3-4.2 2.4-4.3-1.3-1.9-3.4-2.1-4.1-2.1-1.7-.2-3.4 1-4.3 1-.8 0-2.1-1-3.5-1C5.4 6.4 3.7 7.5 2.7 9.2c-2 3.4-.5 8.4 1.4 11.2.9 1.3 2 2.8 3.4 2.7 1.4-.1 1.9-.9 3.5-.9 1.7 0 2.1.9 3.5.9 1.5 0 2.4-1.3 3.3-2.7.5-.8 1-1.6 1.4-2.5C16.9 19.6 16.7 12.8 16.7 12.8zM13.8 4.4c.8-.9 1.2-2.1 1.1-3.4-1.1.1-2.5.7-3.2 1.7-.7.8-1.3 2.1-1.1 3.3C11.6 6.1 12.9 5.3 13.8 4.4z" />
  </svg>
);

export const AndroidIcon = () => (
  <svg width="22" height="24" viewBox="0 0 22 24" fill="white">
    <path d="M1.4 8.3A1.4 1.4 0 0 0 0 9.7v5.7a1.4 1.4 0 0 0 2.8 0V9.7a1.4 1.4 0 0 0-1.4-1.4zm19.2 0a1.4 1.4 0 0 0-1.4 1.4v5.7a1.4 1.4 0 0 0 2.8 0V9.7a1.4 1.4 0 0 0-1.4-1.4zM6.7.2L5.4 1.5l-1 1.1A8.7 8.7 0 0 0 2.4 8h17.2a8.7 8.7 0 0 0-2-5.4L16.6 1.5 15.3.2l-1 1-.7.8a6.7 6.7 0 0 0-5 0L7.7 1.2 6.7.2zM8 5a.8.8 0 1 1 0-1.6A.8.8 0 0 1 8 5zm6 0a.8.8 0 1 1 0-1.6A.8.8 0 0 1 14 5zM2.4 9v10.6A2.4 2.4 0 0 0 4.8 22H5v2.4A1.6 1.6 0 0 0 8.2 24V22h5.6v2.4A1.6 1.6 0 0 0 17 24V22h.2a2.4 2.4 0 0 0 2.4-2.4V9H2.4z" />
  </svg>
);
